import { z } from 'zod';

import { unifyCustomColumnOptionList } from '../utils/formatters.js';
import {
  CustomColumnFormat,
  CustomColumnType,
  OptionItemSchema,
} from './builderTableView.js';

export const CustomColumnSchema = z.object({
  id: z.coerce.string(),
  label: z.string(),
  fieldFormat: z.enum(CustomColumnFormat),
  fieldType: z.enum(CustomColumnType),
  selectValues:
    // TODO: leave "z.array(OptionItemSchema)" only when ff.mdmColumnsForBuyingPlan.enabled && datintell/mdm-mvp
    z
      .array(z.string())
      .or(z.array(z.number()))
      .or(z.array(OptionItemSchema))
      .transform(unifyCustomColumnOptionList),
  editable: z.boolean().prefault(true),
});

export const BuilderSchemaResponseSchema = z.object({
  commonDimensions: z.array(
    z.object({
      label: z.string(),
      dimensions: z.array(z.object({ name: z.string(), label: z.string() })),
    }),
  ),
  customColumns: z.array(CustomColumnSchema),
  otherTechCostFields: z.array(
    z.object({
      name: z.string(),
      label: z.string(),
      autoTechCostPercent: z.string().nullable(),
    }),
  ),
});

export type BuilderSchemaResponse = z.infer<typeof BuilderSchemaResponseSchema>;
export type CustomColumnResponse = z.infer<typeof CustomColumnSchema>;
export type CreateCustomColumnPayload = Omit<CustomColumnResponse, 'id'>;
export type CreateCustomTechCostColumnPayload = {
  autoTechCostPercent: string | null;
  label: string;
};
export type EditCustomColumnPayload = CreateCustomColumnPayload & {
  id: string;
};
export type EditCustomTechCostColumnPayload =
  CreateCustomTechCostColumnPayload & {
    id: string;
  };
